module.exports = __webpack_public_path__ + "media/images/xleague-branding-659f6604a93bf500d8a5b79186c47a73.png";